// WARNING: Do NOT edit this file outside npm-helsecore, it will be reset on build!

import type { ThemeBlockProps } from '@dip/helsecore/src/components/parts/ThemeBlock/ThemeBlock.d';

import React from 'react';
import { ThemeBlock } from '@dip/helsecore/src/components/parts/ThemeBlock/ThemeBlock';


export default (props: Readonly<ThemeBlockProps>) => <ThemeBlock {...props} />
